<template>
  <b-row>
    <b-col cols="12">
      <question-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import QuestionContent from './QuestionContent.vue'

export default {
  components: {
    BRow,
    BCol,

    QuestionContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>